export default {
    assigned_book: 'Assignment',
    challenges: 'Challenges',
    challenge: 'Challenges',
    challenges_desc: 'Overcome challenges and win prizes.',
    complete_the_events: 'Complete the challenges',
    get_beecoins_and_xp: 'Get BeeCoins and XP',
    empty_messages: 'No messages',
    empty_notifications: 'No notifications',
    end_date: 'End date',
    get: 'Get it',
    greet: '¡Hi',
    logout: 'Logout',
    my_books: 'My books',
    articles: 'My articles',
    my_articles: 'My articles',
    books: 'My books',
    my_profile: 'My profile',
    profile: 'My profile',
    my_subscriptions: 'My subscriptions',
    news_from_library: 'Library news',
    news_from_store: 'News from your store',
    no_book: 'You have no book assigned this month.',
    no_book_title: 'Your new book',
    no_book_assigned_title: 'Your new book assignment',
    no_book_content: 'Choose a new book from the library and receive rewards for finishing it.',
    no_book_assigned: 'Your teacher will soon assign you a new book.',
    no_super_recommended: 'We have no recommendations at the momment.',
    own_taste: 'Own taste',
    pages: 'Pages',
    pending_readings: 'Your pending readings',
    pending_readings_desc: 'Go ahead and finish your books.',
    ranking: 'Ranking',
    ranking_subtitle: 'See your position',
    ranking_desc: 'Know the best scores.',
    reminder: 'Reminder',
    rewards: 'Recompensas',
    start_reading: 'Start reading',
    store: 'Store',
    library: 'Library',
    store_desc: 'Buy with your BeeCoins.',
    super_recommended: 'Super recommended!',
    do_click: 'You must click to see the message',
    no_message: 'No message to display',
    notification_text_1:
    'Remember to continue with your assigned book before time runs out. If you want to resume reading, click here. ',
    notification_text_2:
        'You are about to have a unique reading experience. Enjoy the recommendations we have for you. Access immediately and enjoy your suggested readings. ',
    notification_text_3:
        'Everything you need to decorate your platform with a single click. Access amazing additional tools. ',
    your_progress: 'Your progress',
    continue_with_your_reading: 'Continue with your reading',
    assigned_books_and_by_own_taste: 'Assigned books and by own taste',
    continuous_reading: 'Continuous reading',
    position: 'Position',
    player: 'Player',
    accumulated_xp: 'Accumulated XP',
    your_position: 'Your position',
    number_of_days: '{count} day | {count} days',
    starts_in: 'Starts in ',
    congrats: '¡Congrats!',
    reward_earned: 'You have already collected all your rewards. Do you want more? Keep devouring books and challenges to accumulate more achievements!',
    challenge_hasnt_been_completed: 'Challenge has not been completed',
    reward_already_awarded: 'You have collected your well-deserved rewards. What will be your next adventure?',
    items_to_items: '{actual} to {toComplete}',
    assignedBook: {
        diffDays: {
            createdAgo: 'Created',
            createdInLessThan: 'Created in less than',
            days: 'days',
            day: 'day',
            daysAgo: 'days ago',
            dayAgo: 'day ago',
            hours: 'hours',
            hour: 'hour',
            inLess: 'In less than',
            lessThan: 'Less than',
            startsIn: 'Starts in',
            startsInLessThan: 'Starts in less than',
            remain: 'Remain',
            remainLess: 'Remain less than',
            finished: 'Finished',
            finishedInLess: 'Finished in less than',
            finishAt: 'Ends on',
        },
    }
}
